// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"104140ca","708":"c0d36417"}[chunkId] + ".chunk.js";
};